import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL =
  process.env.REACT_APP_FRONTEND_URL || 'https://book.kitkeeper.co.uk';

export const useCanonical = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let link = document.querySelector(
      "link[rel='canonical']"
    ) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', `${SITE_URL.replace(/\/$/, '')}${pathname}`);
  }, [pathname]);
};
